import List from '../../views/event/List.vue';

// イベント情報一覧
window.Vue.component('event-list', List);
